import type { RootState } from "@/redux/store";

export const selectAuth = (state: RootState) => state.auth;

export const selectCurrentUser = (state: RootState) => selectAuth(state).user;

export const selectAccessToken = (state: RootState) =>
  selectAuth(state).accessToken;

export const selectIsAuthenticated = (state: RootState) =>
  selectAuth(state).isAuthenticated;

export const selectAuthLoading = (state: RootState) =>
  selectAuth(state).loading;

export const selectAuthError = (state: RootState) => selectAuth(state).error;
